import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SidebarDashboardIcon from './assets/Home.png';
import SidebarConversationIcon from './assets/Inbox.png';
import SidebarTaxIcon from './assets/Group 47790.png';
import SidebarPackagesIcon from './assets/Icon material-money-off.png';
import SidebarDisputeIcon from './assets/Group 47740.png';
import SidebarCoursesIcon from './assets/Group 47741.png';
import SidebarAssociateIcon from './assets/Group 47791.png';
import SidebarPartnerIcon from './assets/Group 47807.png';
import SidebarDelegationsIcon from './assets/Group 54321.png';
import BlogManagement from './assets/BlogManagement.png';
import SettingsIcon from './assets/Settings.png';
import VisitorsHub from './assets/VisitorsHub.png';
import ManageLearnerIcon from './assets/ManageLearnerNew.svg';

const SidebarItem = ({ icon, label, onClick, active }) => (
    <button
        onClick={onClick}
        className={`relative flex w-full items-center gap-4 rounded-[10px] px-6 py-3 text-white font-semibold hover:bg-[rgba(255,255,255,0.12)] active:bg-[rgba(255,255,255,0.18)] ${active ? 'bg-[rgba(255,255,255,0.15)] shadow-[inset_0_0_0_1px_rgba(255,255,255,0.25)]' : ''}`}
        style={{ fontFamily: 'Segoe UI, Arial, sans-serif', fontSize: 16, minHeight: 48, maxHeight: 56, whiteSpace: 'nowrap' }}
    >
        {active ? <span className="absolute left-0 top-0 h-full w-[6px] rounded-r-[6px] bg-white"></span> : null}
        {icon ? <img src={icon} alt="icon" style={{ width: 28, height: 28, objectFit: 'contain' }} /> : null}
        <span className="Regularfont text-[15px]" style={{ fontWeight: 500 }}>{label}</span>
        <span className="pointer-events-none absolute bottom-0 left-0 right-0 h-px bg-[rgba(255,255,255,0.25)]"></span>
    </button>
);

const Sidebar = ({ activeItem, onItemClick, isOpen, onClose }) => {
    const navigate = useNavigate();
    const location = useLocation();

    // Automatically determine active item based on current route
    const getActiveItemFromPath = () => {
        const path = location.pathname;
        if (path === "/") return "Dashboard";
        if (path.includes("/admin/published-courses") || path.includes("/admin/course/create")) return "Manage Courses";
        if (path.includes("/admin/delegate-institute-management")) return "Delegate Institute Management";
        if (path.includes("/admin/delegate-management")) return "Delegate Management";
        if (path.includes("/admin/manage-partners")) return "Manage Partner";
        if (
            path.includes("/admin/manage-learners") ||
            path.includes("/admin/manage-learner/")
        ) return "Manage Learner";
        // if (path.includes("/admin/packages-and-plan")) return "Packages & Plan";
        if (path.includes("/admin/partner/packages")) return "Packages & Plan";
        if (path.includes("/admin/manage-packages")) return "Packages";
        if (path.includes("/inbox")) return "Conversation";
        if (path.includes("/admin/discount-management")) return "Discount Management";
        // Add more path mappings as needed
        return activeItem; // fallback to prop
    };

    const currentActive = activeItem || getActiveItemFromPath();

    // Sync parent state when route changes
    useEffect(() => {
        const detectedItem = getActiveItemFromPath();
        if (onItemClick && detectedItem !== activeItem) {
            onItemClick(detectedItem);
        }
    }, [location.pathname]);

    const handleItemClick = (item) => {
        // Handle navigation for each item
        switch(item) {
            case "Dashboard":
                navigate("/");
                break;
            case "Manage Courses":
                navigate("/admin/published-courses");
                break;
            case "Manage Partner":
                navigate("/admin/manage-partners");
                break;
            case "Manage Learner":
                navigate("/admin/manage-learners");
                break;
            case "Delegate Institute Management":
                navigate("/admin/delegate-institute-management");
                break;
            case "Delegate Management":
                navigate("/admin/delegate-management");
                break;
            case "Conversation":
                navigate("/inbox");
                break;
            case "Discount Management":
                navigate("/admin/discount-management");
                break;
            case "Packages & Plan":
                // navigate("/admin/packages-and-plan");
                navigate("/admin/partner/packages");
                break;
            case "Packages":
                navigate("/admin/manage-packages");
                break;
            case "Blog Management":
                navigate("/admin/manage-blogs");
                break;
            
            case "Visitors Hub":
                navigate("/admin/site-analytics");
                break;
            // Add more cases as needed
            default:
                break;
        }
        // Call the parent's onItemClick to update active state
        if (onItemClick) onItemClick(item);
        // Close sidebar on mobile
        if (onClose) onClose();
    };

    return (
        <>
            <style>{`
                .admin-sidebar-nav {
                    scrollbar-width: thin;
                    scrollbar-color: rgba(255, 255, 255, 0.45) transparent;
                }
                .admin-sidebar-nav::-webkit-scrollbar {
                    width: 6px;
                }
                .admin-sidebar-nav::-webkit-scrollbar-thumb {
                    background-color: rgba(255, 255, 255, 0.45);
                    border-radius: 3px;
                }
            `}</style>
            {/* Mobile Overlay */}
            {isOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={onClose}
                />
            )}
            
            {/* Sidebar */}
            <aside
                className={`flex h-screen w-[260px] flex-col p-0 z-50 fixed left-0 top-0 transform transition-transform duration-300 ease-in-out ${
                    isOpen ? 'translate-x-0' : '-translate-x-full'
                } lg:translate-x-0`}
                style={{ background: 'linear-gradient(180deg, #62D1F3 0%, #6C63F5 100%)', boxShadow: '0 0 24px 0 rgba(122,92,245,0.08)' }}
            >
            <div className="flex shrink-0 items-center justify-center pt-8" style={{ height: 72 }}>
               <img src={`${process.env.PUBLIC_URL}/assets/logo/vli_logo.png`} alt="VLI" className="h-8 w-auto brightness-0 invert" onError={(e)=>{e.currentTarget.style.display='none'}} />
            </div>
            <nav
                className="admin-sidebar-nav flex min-h-0 flex-1 flex-col overflow-x-hidden overflow-y-auto pb-6"
                aria-label="Admin navigation"
            >
            <div className="mt-auto flex w-full flex-col gap-2">
            <SidebarItem active={currentActive === "Dashboard"} icon={SidebarDashboardIcon} label="Dashboard" onClick={() => handleItemClick("Dashboard")} />
            <SidebarItem active={currentActive === "Conversation"} icon={SidebarConversationIcon} label="Conversation" onClick={() => handleItemClick("ConversationNew")} />
            <SidebarItem active={currentActive === "Manage TAX/GST"} icon={SidebarTaxIcon} label="Manage TAX/GST" onClick={() => handleItemClick("Manage TAX/GST")} />
            <SidebarItem active={currentActive === "Discount Management"} icon={SidebarTaxIcon} label="Discount Management" onClick={() => handleItemClick("Discount Management")} />
            <SidebarItem active={currentActive === "Packages & Plan"} icon={SidebarPackagesIcon} label="Packages & Plan" onClick={() => handleItemClick("Packages & Plan")} />
            <SidebarItem active={currentActive === "Packages"} icon={SidebarPackagesIcon} label="Packages" onClick={() => handleItemClick("Packages")} />
            <SidebarItem active={currentActive === "Dispute Management"} icon={SidebarDisputeIcon} label="Dispute Management" onClick={() => handleItemClick("Dispute Management")} />
            <SidebarItem active={currentActive === "Manage Courses"} icon={SidebarCoursesIcon} label="Manage Courses" onClick={() => handleItemClick("Manage Courses")} />
            <SidebarItem active={currentActive === "Manage Learner"} icon={ManageLearnerIcon} label="Manage Learner" onClick={() => handleItemClick("Manage Learner")} />
            <SidebarItem active={currentActive === "Associate Member"} icon={SidebarAssociateIcon} label="Associate Member" onClick={() => handleItemClick("Associate Member")} />
            <SidebarItem active={currentActive === "Manage Partner"} icon={SidebarPartnerIcon} label="Manage Partner" onClick={() => handleItemClick("Manage Partner")} />
            <SidebarItem active={currentActive === "Delegate Institute Management"} icon={SidebarDelegationsIcon} label="Delegate Institute Management" onClick={() => handleItemClick("Delegate Institute Management")} />
            <SidebarItem active={currentActive === "Blog Management"} icon={BlogManagement} label="Blog Management" onClick={() => handleItemClick("Blog Management")} />
            <SidebarItem active={currentActive === "Visitors Hub"} icon={VisitorsHub} label="Visitors Hub" onClick={() => handleItemClick("Visitors Hub")} />
            <SidebarItem active={currentActive === "Settings"} icon={SettingsIcon} label="Settings" onClick={() => handleItemClick("Settings")} />
            </div>
            </nav>
            </aside>
        </>
    );
};

export default Sidebar;